import { HttpClient, HttpEvent, HttpHeaders, HttpResponse } from "@angular/common/http";
import { map, Observable, tap } from "rxjs";
import { AuthService } from "./auth.service";
import { AbstractHttpService } from "./http-abstract.service";
import { Injectable } from "@angular/core";
import { AgentDto, AppRoleDto } from "./dto";

@Injectable({
	providedIn: 'root'
})
export class HttpAppRoleService extends AbstractHttpService {
	constructor(httpClient: HttpClient, authService: AuthService) {
		super(httpClient, '/api/gui/app_role', authService);
	}

	public getAll(): Observable<AppRoleDto[]> {
		return super.doGet(true, `/`);
	}
	public get(id: number): Observable<AppRoleDto> {
		return super.doGet(true, `/${id}`);
	}
	public createRole(input: AppRoleDto): Observable<AppRoleDto> {
		return super.doPost(true, `/`, input);
	}
	public editRole(id: number, input: AppRoleDto): Observable<AppRoleDto> {
		return super.doPost(true, `/${id}`, input);
	}

	public savePermissions(input: AppRoleDto[]): Observable<AppRoleDto[]> {
		return super.doPost(true, `/permissions`, input);
	}
	public editAgentRoles(input: AgentDto): Observable<AgentDto> {
		return super.doPost(true, `/${input.id}/app_role`, input);
	}
}
